import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings as SettingsIcon, User, Bell, Lock, ArrowLeft } from 'lucide-react';
import { useSession } from '../contexts/SessionContext';
import { UserProfile } from './settings/UserProfile';

export function Settings() {
  const [activeTab, setActiveTab] = useState('user');
  const navigate = useNavigate();
  const { user } = useSession();

  const tabs = [
    { id: 'user', label: 'User Profile', icon: User },
    { id: 'notifications', label: 'Notifications', icon: Bell },
    { id: 'security', label: 'Security', icon: Lock },
  ];

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-[#FCFCFD] dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <button
            onClick={goBack}
            className="flex items-center text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
          >
            <ArrowLeft className="h-5 w-5 mr-2" />
            Back
          </button>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-lg shadow">
          <div className="p-6 border-b border-gray-200 dark:border-gray-700">
            <div className="flex items-center">
              <SettingsIcon className="h-6 w-6 text-indigo-600 dark:text-indigo-400 mr-2" />
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Settings</h2>
            </div>
          </div>

          <div className="p-6">
            {/* Tabs */}
            <div className="border-b border-gray-200 dark:border-gray-700">
              <nav className="-mb-px flex space-x-8">
                {tabs.map((tab) => {
                  const Icon = tab.icon;
                  return (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`
                        flex items-center py-4 px-1 border-b-2 font-medium text-sm
                        ${activeTab === tab.id
                          ? 'border-indigo-500 text-indigo-600 dark:text-indigo-400'
                          : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                        }
                      `}
                    >
                      <Icon className="h-5 w-5 mr-2" />
                      {tab.label}
                    </button>
                  );
                })}
              </nav>
            </div>

            {/* Content */}
            <div className="mt-6">
              {activeTab === 'user' && <UserProfile />}
              {activeTab === 'notifications' && (
                <div className="text-gray-500 dark:text-gray-400">
                  Notification settings coming soon
                </div>
              )}
              {activeTab === 'security' && (
                <div className="text-gray-500 dark:text-gray-400">
                  Security settings coming soon
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}